var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.228 90.954V55.4479L76.6852 20L27.2324 48.6489V72.4165H41.063V86.8862H27V125.53H49.3148L86.2736 140L132.995 125.123V105.133H119.165V90.8959H133.228V90.954ZM124.918 111.758V117.685L86.2736 130.47L55.0678 118.15H35.7167V93.9177H85.6344C85.6344 93.9177 89.0048 94.9637 89.0048 98.3923C89.0048 101.763 87.7264 102.867 85.6344 102.867H72.0363C72.0363 102.867 69.247 102.634 69.247 107.109C69.247 111.584 71.5714 111.758 71.5714 111.758H124.918ZM96.2688 85.0266C96.2688 85.0266 77.1501 72.3002 75 70.3826C72.8499 68.4649 74.5932 65.7337 76.5109 63.816C78.4286 61.8983 80.1138 62.77 82.2639 64.2228C84.414 65.7337 88.0169 68.0581 89.2954 68.6973C90.5738 69.3366 91.6199 69.7433 93.1308 68.4649C94.6416 67.1864 95.4552 65.908 95.6877 64.2228C95.9201 62.5375 95.2809 61.4334 93.5375 60.6199C91.8523 59.7482 74.0121 46.7893 72.2688 46.615C70.5254 46.3245 38.2736 57.8305 35.7167 58.4697V53.5884L75.2324 30.46L124.743 59.9806V85.0266H96.2688Z",
    fill: "#F38235"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.228,
    height: 120,
    fill: "white",
    transform: "translate(27 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhb);
export default __webpack_public_path__ + "static/media/ghb.c7415111.svg";
export { ForwardRef as ReactComponent };